import { render } from "./PluginDetails.vue?vue&type=template&id=029cc282&scoped=true&ts=true"
import script from "./PluginDetails.vue?vue&type=script&lang=ts"
export * from "./PluginDetails.vue?vue&type=script&lang=ts"

import "./PluginDetails.vue?vue&type=style&index=0&id=029cc282&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029cc282"]])

export default __exports__